import type { SVGProps } from 'react'
const LineChevronLeftSmall = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="m14.22 18.78-5.895-5.895a1.26 1.26 0 0 1 0-1.77L14.22 5.22l1.06 1.06L9.56 12l5.72 5.72z"
		/>
	</svg>
)
export { LineChevronLeftSmall }
